export const UPDATE_ASK_VYRILL_STATE = "UPDATE_ASK_VYRILL_STATE";
export const RESET_ASK_VYRILL_STATE = "RESET_ASK_VYRILL_STATE";
export const UPDATE_SINGLE_MESSAGE = "UPDATE_SINGLE_MESSAGE";
export const UPDATE_ASK_VYRILL_MODAL = "UPDATE_ASK_VYRILL_MODAL";

type ActionPayload = {
  [key: string]: any;
};

// Define the action type
type UpdateAskVyrillStateAction = {
  type: typeof UPDATE_ASK_VYRILL_STATE;
  data: ActionPayload;
};

// Define the action creator function
export const updateAskVyrillState = (
  data: ActionPayload
): UpdateAskVyrillStateAction => ({
  type: UPDATE_ASK_VYRILL_STATE,
  data,
});

type UpdateSingleMessageAction = {
  type: typeof UPDATE_SINGLE_MESSAGE;
  data: ActionPayload;
};

export const updateSingleMessage = (
  data: ActionPayload
): UpdateSingleMessageAction => ({
  type: UPDATE_SINGLE_MESSAGE,
  data,
});

type askVyrillModalAction = {
  type: typeof UPDATE_ASK_VYRILL_MODAL;
  data: ActionPayload;
};

export const updateAskVyrillModal = (
  data: ActionPayload
): askVyrillModalAction => ({
  type: UPDATE_ASK_VYRILL_MODAL,
  data,
});
